import { Tag } from '@cian/components';
import * as React from 'react';

import { IApartmentTag } from '../../../state/tags/definitions/apartment';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IApartmentTagItemProps {
  tag: IApartmentTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const ApartmentTagItem = ({ tag, onDeleteClick, withNewTag }: IApartmentTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {(tag.value && 'Только апартаменты') || 'Без апартаментов'}
    </TagComponent>
  );
};
